var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSouthAfrica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1197_18536)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1197_18536)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.05,
    y: -0.815063,
    width: 15.95,
    height: 6.75,
    fill: "#DE1529"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.05,
    y: 5.93494,
    width: 15.95,
    height: 6.75,
    fill: "#003789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 -0.715027H3L9.65 3.73497H19V8.18497H9.65L3 12.635H-1V-0.715027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 -0.715027H1.425L9.375 4.60997H19V7.30997H9.375L1.425 12.635H-1V-0.715027Z",
    fill: "#007847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 0.909912L6.6 5.95991L-1 11.0099V0.909912Z",
    fill: "#FFB915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 1.95996L5 5.95996L-1 9.95996V1.95996Z",
    fill: "black"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-0.5H-0.5V0H0ZM18 0H18.5V-0.5H18V0ZM18 12V12.5H18.5V12H18ZM0 12H-0.5V12.5H0V12ZM0 0.5H18V-0.5H0V0.5ZM17.5 0V12H18.5V0H17.5ZM18 11.5H0V12.5H18V11.5ZM0.5 12V0H-0.5V12H0.5Z",
    fill: "#A8A8A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_18536"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V12H0V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1197_18536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13.35,
    fill: "white",
    transform: "translate(-1 -0.715088)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/south-africa.7ba208b85d13feaa116cd3515c6e05cf.svg";
export { ForwardRef as ReactComponent };